import { useState } from 'react';
import { GrownUpsScreen } from './screens/GrownUpsScreen';
import { HomeScreen } from './screens/HomeScreen';
import { NewMovieScreen } from './screens/NewMovieScreen';
import { HelpScreen } from './screens/HelpScreen';
import { MoviesScreen } from './screens/MoviesScreen';
import { CaptureScreen } from './screens/CaptureScreen';
import { PreviewScreen } from './screens/PreviewScreen';
import { createProject } from './storage/projectRepository';

type Screen =
  | { name: 'home' }
  | { name: 'new' }
  | { name: 'movies' }
  | { name: 'help' }
  | { name: 'capture'; projectId: string }
  | { name: 'preview'; projectId: string }
  | { name: 'grownups' };

function initialScreen(): Screen {
  if (window.location.hash === '#grownups') {
    history.replaceState(null, '', window.location.pathname);
    return { name: 'grownups' };
  }
  return { name: 'home' };
}

export default function App() {
  const [screen, setScreen] = useState<Screen>(initialScreen);
  const home = () => setScreen({ name: 'home' });

  switch (screen.name) {
    case 'home':
      return <HomeScreen onNew={() => setScreen({ name: 'new' })} onMovies={() => setScreen({ name: 'movies' })} onHelp={() => setScreen({ name: 'help' })} onGrownUps={() => setScreen({ name: 'grownups' })} />;
    case 'grownups':
      return <GrownUpsScreen onBack={home} />;
    case 'new':
      return <NewMovieScreen onBack={home} onCreate={async (title) => {
        const project = await createProject(title);
        setScreen({ name: 'capture', projectId: project.id });
      }} />;
    case 'movies':
      return <MoviesScreen onBack={home} onNew={() => setScreen({ name: 'new' })} onOpen={(projectId) => setScreen({ name: 'preview', projectId })} />;
    case 'help':
      return <HelpScreen onBack={home} />;
    case 'capture':
      return <CaptureScreen projectId={screen.projectId} onHome={home} onPreview={() => setScreen({ name: 'preview', projectId: screen.projectId })} />;
    case 'preview':
      return <PreviewScreen projectId={screen.projectId} onHome={home} onCamera={() => setScreen({ name: 'capture', projectId: screen.projectId })} />;
  }
}

